/**
 * 卡片页
 */
import React from 'react';
import PropTypes from 'prop-types';
import { getLocalStorage } from '@/assets/js/storage';

class Main extends React.Component {

    componentDidMount() {
        const userInfo = getLocalStorage('auth') ? JSON.parse(getLocalStorage('auth')).userInfo : null;
        const { accountType } = userInfo;

        if (accountType == 'COMPANY') {
            this.props.history.replace({ pathname: '/home/permissions/structure' });
        } else {
            this.props.history.replace({ pathname: '/home/permissions/structure' });
        }
    }


    render() {
        return (
            <div>权限管理-卡片页</div>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object, // 路由
};

export default Main;